export default __webpack_public_path__ + "static/media/lock-color.14c2303f.svg";